import React from "react";

// Iron House Design System — Button (copiado do DS oficial, + import React).
export function Button(props) {
  const {
    children,
    variant = "primary",
    size = "md",
    disabled = false,
    fullWidth = false,
    onClick,
    type = "button",
    className = "",
    ...rest
  } = props;

  const baseStyles = {
    fontFamily: "var(--font-display)",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "var(--tracking-wide)",
    border: "none",
    cursor: disabled ? "not-allowed" : "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "var(--space-2)",
    transition: `all var(--duration-normal) var(--ease-default)`,
    opacity: disabled ? 0.5 : 1,
    width: fullWidth ? "100%" : "auto",
    textDecoration: "none",
    lineHeight: 1,
  };

  const sizeStyles = {
    sm: { fontSize: "12px", padding: "8px 16px", borderRadius: "var(--radius-sm)" },
    md: { fontSize: "14px", padding: "12px 24px", borderRadius: "var(--radius-md)" },
    lg: { fontSize: "16px", padding: "16px 32px", borderRadius: "var(--radius-md)" },
  };

  const variantStyles = {
    primary: { background: "var(--color-green)", color: "var(--color-black)" },
    secondary: { background: "var(--color-iron)", color: "var(--color-white)" },
    dark: { background: "var(--color-black)", color: "var(--color-white)" },
    outline: { background: "transparent", color: "var(--color-white)", border: "2px solid var(--color-green)" },
    ghost: { background: "transparent", color: "var(--text-primary)" },
  };

  const [hovered, setHovered] = React.useState(false);
  const [pressed, setPressed] = React.useState(false);

  const hoverStyles =
    hovered && !disabled
      ? {
          primary: { background: "var(--color-green-dark)" },
          secondary: { background: "var(--color-iron-dark)" },
          dark: { background: "var(--neutral-800)" },
          outline: { background: "rgba(153,196,45,0.1)" },
          ghost: { background: "var(--neutral-100)" },
        }[variant]
      : {};

  const pressStyles = pressed && !disabled ? { transform: "scale(0.97)" } : {};

  const combinedStyles = {
    ...baseStyles,
    ...sizeStyles[size],
    ...variantStyles[variant],
    ...hoverStyles,
    ...pressStyles,
  };

  return (
    <button
      type={type}
      disabled={disabled}
      style={combinedStyles}
      className={className}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
